<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-22 10:37:30
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:40:47
-->
<template>
  <div class="innovative innovative-accufficas" :class="{textj: language != 'en'}" ref="accufficas">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accufficas.title')"></div>
    </div>
    <div class="overhid p-b-40">
      <div class="p-30 p-t-40 p-b-20">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accufficas.list[0].title')"></div>
      </div>
      <div class="p-l-18 p-r-16">
        <img class="wid100" :src="$t('product.accufficas.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 p-t-15 textj">
        <p v-for="item, index in $t('product.accufficas.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="accufficas-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.accufficas.list[1].title')"></div>
          <div class="accufficas-characteristics-box">
            <div class="p-t-20 p-b-20" v-for="item, index in $t('product.accufficas.list[1].des')" :key="index">
              <div class="flex justify_content_center p-b-15 textc">
                <img class="accufficas-characteristics-img" :src="item.img" alt="" srcset="">
              </div>
              <div class="innovative-wrap-item-title fz-30 p-b-25 textc" v-html="item.title"></div>
              <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="language != 'en'" class="accufficas-advantages">
      <div class="innovative-item-title widauto ilblk p-r-100" :class="language == 'en' ? 'heiauto' : ''" v-html="$t('product.accufficas.list[2].title')"></div>
      <div class="innovative-accufficas-m-h">
        <div>
          <img class="wid100" :src="$t('product.accufficas.list[2].img1')" alt="" srcset="">
        </div>
        <div class="p-t-30">
          <img class="wid100" :src="$t('product.accufficas.list[2].img2')" alt="" srcset="">
        </div>
        <div class="flex justify_content_center p-t-30">
          <div class="m-h-sign" :class="{textc: language == 'en'}" v-html="$t('product.accufficas.list[2].m_imgDes')"></div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accufficas.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.accufficas.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accufficas {
  .accufficas-characteristics {
    background-image: url('~@/assets/images/innovate/AccuFFicas/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .accufficas-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 10%;
    }
    .accufficas-characteristics-img {
      max-height: 68px;
    }
  }
  .accufficas-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding-bottom: 50px;
    padding: 50px 30px;
  }
  .innovative-accufficas-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 30px 15px;
    .m-h-sign {
      background: linear-gradient(90deg, #0556EA 0%, #02C2D0 100%);
      color: #ffffff;
      padding: 10px 21px;
      line-height: 38px;
    }
  }
}
</style>
